// Mind2Magic CRM — Orchestrator
// Extracted from index.html inline script (Phase 1, Step 3).
// renderAll() and showView() — the two top-level render coordinators.

import { store } from './store.js'

function renderAll() {
    fixConsentTextDestinations();
    populateMonthFilter();
    renderPipeline();
    renderClients();
    renderFrecuentes();
    renderM2M();
    renderProximos();
    renderHistorico();
    renderWatched();
    renderTeam();
    renderDashboard();
    updateStats();
    updateBadges();
    // Empresas renders
    if (store.crmMode === 'empresas') {
        populateEmpCompanyDropdowns();
        renderEmpPipeline();
        renderEmpCompanies();
    }
    // Mantener búsqueda activa si hay texto en el campo
    const searchInput = document.getElementById('searchInput');
    if (searchInput && searchInput.value.trim()) {
        handleSearch(searchInput.value);
    }
}

function showView(v) {
    document.querySelectorAll('.view').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('.nav-item').forEach(el => el.classList.remove('active'));
    document.getElementById(v + 'View')?.classList.add('active');
    document.querySelector(`[data-view="${v}"]`)?.classList.add('active');
    const titles = { dashboard: 'Dashboard', kpis: 'KPIs', pipeline: 'Pipeline Turismo', proximos: 'Próximos a Viajar', calendario: 'Calendario', tareas: 'Tareas', clients: 'Clientes', frecuentes: 'Viajeros Frecuentes', m2m: 'Viajeros M2M', historico: 'Historico', watched: 'Seguimiento', import: 'Importar Datos', whatsapp: 'WhatsApp', formularios: 'Formularios', contenido: 'Contenido', equipo: 'Equipo', empPipeline: 'Pipeline Empresas', empCompanies: 'Empresas', empInvoice: 'Resumen Mensual' };
    document.getElementById('pageTitle').textContent = titles[v] || v;

    // Limpiar búsqueda al cambiar de vista — stale text is confusing
    const searchInput = document.getElementById('searchInput');
    if (searchInput && searchInput.value.trim()) {
        searchInput.value = '';
        // Reset any hidden cards from previous search
        document.querySelectorAll('.card, .client-card').forEach(c => c.style.display = '');
    }
    store.calendarSearchQuery = '';

    if (v === 'whatsapp') { renderWhatsAppInbox(); window.updateWhatsAppInboxBadge?.(); }
    if (v === 'kpis') renderKPIs();
    if (v === 'calendario') renderCalendario();
    if (v === 'tareas') renderTareas();
    if (v === 'empPipeline') { populateEmpCompanyDropdowns(); renderEmpPipeline(); }
    if (v === 'empCompanies') renderEmpCompanies();
    if (v === 'empInvoice') { populateEmpCompanyDropdowns(); renderInvoice(); }
    if (v === 'formularios') refreshFormSubmissions();
    if (v === 'contenido') renderContenido();

    // Recalculate scroll wrapper heights for the new active view
    requestAnimationFrame(() => _recalcViewScrollWraps());
}


// ========== WINDOW BRIDGE ==========
Object.assign(window, {
    renderAll,
    showView,
});
